import { z } from "zod";
/**
 * A claimini ID (eClaim entity identifier, e.g. of an Incident or Person).
 * eClaim IDs are always exactly 4 characters. Rejects values that would break
 * a URL path (slashes, ?, #, spaces, etc.).
 */
export const claiminiIdSchema = z
    .string()
    .length(4, "claiminiId must be exactly 4 characters")
    .regex(/^[A-Za-z0-9\-_.]+$/, "claiminiId must only contain alphanumeric characters, hyphens, underscores, or dots");
